const BACKUP_REMINDER_DAYS = 30;
const BACKUP_REMINDER_CONTRIBS = 5;

export interface BackupState {
  last_backup_export_at: string | null;
  contributions_since_last_backup: number;
}

export function shouldShowBackupReminder(backup: BackupState, nowIso: string): boolean {
  if (backup.contributions_since_last_backup >= BACKUP_REMINDER_CONTRIBS) return true;
  if (!backup.last_backup_export_at) return false;
  const daysSince = (Date.parse(nowIso) - Date.parse(backup.last_backup_export_at)) / (1000 * 60 * 60 * 24);
  return daysSince >= BACKUP_REMINDER_DAYS;
}
